import React from "react";
import SingleUserComponent from "../components/users/UserProfile/SingleUserComponent";

export default function ViewUserProfilePage() {
  return <SingleUserComponent />;
}
